let csrf = ''
export function setCsrf(value) { csrf = value }
export async function api(path, method = 'GET', body) {
  const response = await fetch('/api' + path, {
    method, credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
    ...(body === undefined ? {} : { body: JSON.stringify(body) })
  })
  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    const error = new Error(typeof data.detail === 'string' ? data.detail : 'Перевірте заповнені поля та повторіть спробу.')
    error.status = response.status
    throw error
  }
  return data
}
